import { defineComponent as _defineComponent } from 'vue'
import {onMounted} from 'vue';
import EnvironmentTheme from './env/services/EnvironmentTheme';
import {setupTheme} from './services/theme/ThemeService';
import LModal from '@/components/L/Modal/LModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(() => {
  setupTheme(EnvironmentTheme.LENDI);
})

return { __sfc: true,LModal }
}

})